// extracted by mini-css-extract-plugin
module.exports = {"container":"IconMain_container__19800","welcome":"IconMain_welcome__2nP21"};